import { LevelGranulometry } from '../../LevelGranulometry';

export const isFirstBasementLevel = (levelGranulometry: LevelGranulometry): boolean =>
  levelGranulometry.level === -1;
